import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
    lang: "en",
    setLang: () => {},
    t: translations.en,
});

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        if (typeof window === "undefined") return "en";
        return window.localStorage.getItem("bink_lang") || "en";
    });

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.localStorage.setItem("bink_lang", lang);
            document.documentElement.lang = lang;
        }
    }, [lang]);

    const value = useMemo(
        () => ({
            lang,
            setLang,
            t: translations[lang] || translations.en,
        }),
        [lang]
    );

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
